globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmailSentIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_6961_56186)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M45.3307 34.5263V29.3327C45.3307 28.6254 45.0498 27.9472 44.5497 27.4471C44.0496 26.947 43.3713 26.666 42.6641 26.666H21.3307C20.6235 26.666 19.9452 26.947 19.4451 27.4471C18.945 27.9472 18.6641 28.6254 18.6641 29.3327V34.532",
        stroke: "#693EB5",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8 26.666L27.2 41.066C28.5848 42.1046 30.269 42.666 32 42.666C33.731 42.666 35.4152 42.1046 36.8 41.066L56 26.666",
        stroke: "#693EB5",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M53.9093 22.7013L36.864 9.6484C35.4679 8.57933 33.7585 8 32.0001 8C30.2417 8 28.5323 8.57933 27.1363 9.6484L10.0907 22.7013C9.44047 23.1993 8.91368 23.8402 8.55112 24.5745C8.18857 25.3089 7.99999 26.1168 8 26.9358V48C8 50.1217 8.84286 52.1566 10.3431 53.6569C11.8434 55.1571 13.8783 56 16 56H48C50.1217 56 52.1566 55.1571 53.6569 53.6569C55.1571 52.1566 56 50.1217 56 48V26.9356C56 26.1167 55.8114 25.3088 55.4488 24.5745C55.0863 23.8402 54.5595 23.1992 53.9093 22.7013Z",
        stroke: "#693EB5",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6961_56186",
        children: /*#__PURE__*/_jsx("rect", {
          width: "64",
          height: "64",
          fill: "white"
        })
      })
    })]
  });
}